import React from 'react';
import { Apify } from '../Apify';
import I18N from '../I18N';
import { T } from '../traks';

const LoadingNumbers = () => {
	return (
		<div className="d-flex flex-row py-4">
			<div className="flex-fill">
				<span className="ad_front_nums">-</span><br />
				<span className="ad_front_nums_legend"><T>Users</T></span>
			</div>
			<div className="flex-fill">
				<span className="ad_front_nums">-</span><br />
				<span className="ad_front_nums_legend"><T>Games</T></span>
			</div>
			<div className="flex-fill">
				<span className="ad_front_nums">-</span><br />
				<span className="ad_front_nums_legend"><T>Trades</T></span>
			</div>
		</div>
	);
}

export default Apify("/z/random_number_generator")
	.with_response_prop("numbers")
.wrap((props) => {
	const { numbers } = props;

	const user_count = numbers.NumberOfUsersDK + numbers.NumberOfUsersSE + numbers.NumberOfUsersDE;

	return (
		<div className="d-flex flex-row py-4">
			<div className="flex-fill">
				<span className="ad_front_nums">{I18N.intval(user_count)}</span><br />
				<span className="ad_front_nums_legend"><T>Users</T></span>
			</div>
			<div className="flex-fill">
				<span className="ad_front_nums">{I18N.intval(numbers.NumberOfGames)}</span><br />
				<span className="ad_front_nums_legend"><T>Games</T></span>
			</div>
			<div className="flex-fill">
				<span className="ad_front_nums">{I18N.intval(numbers.NumberOfTrades)}</span><br />
				<span className="ad_front_nums_legend"><T>Trades</T></span>
			</div>
		</div>
	);
}, LoadingNumbers);



// WEBPACK FOOTER //
// ./src/c/RandomNumberGenerator.js